<template>
  <div class="list-container-files">
    <FileListItem
      v-for="(file, index) in files"
      :id="index"
      :key="index"
      :title="file.name"
      :selected="index === selectedIndex"
      @click="emits('selectFile', file, index)"
    />
  </div>
</template>
<script lang="ts" setup>
import { toRefs, ref } from 'vue'
import FileListItem from '@/components/general/files/FileListItem/FileListItem.vue'
import { FILE } from '@/interfaces/misc.interface'

interface PROPS {
  files: (File | FILE)[]
  selectedIndex: number
}
interface EMITS {
  (e: 'selectFile', file: File | FILE, index: number): void
}
const props = defineProps<PROPS>()
const { files = ref([]), selectedIndex = -1 } = toRefs(props)

const emits = defineEmits<EMITS>()
</script>
<style scoped lang="scss">
.list-container-files {
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  border-radius: 4px;
  min-height: 75px;
}
</style>
